<div class="rfr_input-wrapper">
  <ion-item
    lines="none"
    [style]="style"
    [class]="class"
    [ngClass]="{
      'rfr_ion-item': !readonly,
      'rfr_ion-item_read-only': readonly,
      'rfr_ion-item_error': !readonly && error,
    }"
  >
    <ion-icon *ngIf="showIcon" name="calendar-outline" class="rfr-calendar-icon" style="margin-right: 5px;"></ion-icon>
    <ion-input
      class="rfr_input"
      labelPlacement="floating"
      [value]="value"
      (ionBlur)="onBlur()"
      [disabled]="disabled"
      [readonly]="true"
      [placeholder]="placeholder"
      [pattern]="pattern"
      [min]="min"
      type="date_event"
      [id]="id"
      [max]="max"
      [maxlength]="maxLength"
    >
      <div class="rfr-label-text" slot="label">
        {{ labelText }} <ion-text color="danger" *ngIf="isRequired">*</ion-text>
      </div>
    </ion-input>
    <ion-modal
      class="date-time-modal"
      [trigger]="id"
      [keepContentsMounted]="true"
      [initialBreakpoint]="1"
    >
      <ng-template>
        <div style="overflow-y: auto;">
          <ion-datetime
            color="tertiary"
            presentation="date"
            [(ngModel)]="date_event"
            mode="md"
            (ionChange)="datePick()"
            [showClearButton]="true"
            [showDefaultButtons]="true"
            [cancelText]="'cancelBtn' | translate"
            [doneText]="'okBtn' | translate"
            [clearText]="'clear' | translate"
            (ionClear)="clearDate()"
            min="{{ minDayDate }}"
            max="{{ todayDate }}"
          >
          </ion-datetime>
        </div>
      </ng-template>
      <ng-template ngIf="!maxToday">
        <div style="overflow-y: auto;">
          <ion-datetime
            color="tertiary"
            presentation="date"
            [(ngModel)]="date_event"
            (ionClear)="clearDate()"
            [cancelText]="'cancelBtn' | translate"
            [doneText]="'okBtn' | translate"
            [clearText]="'clear' | translate"
            mode="md"
            (ionChange)="datePick()"
            [showClearButton]="true"
            [showDefaultButtons]="true"
          >
          </ion-datetime>
        </div>
      </ng-template>
    </ion-modal>
  </ion-item>
  <ng-content select="[slot=error-message]"></ng-content>
</div>
